import React from 'react'
import { styled } from '@paintscout/ui'
import type { ItemTableCellProps } from '../../../ItemTable/ItemTableCell'
import ItemTableCell from '../../../ItemTable/ItemTableCell'

const AreaSubstrateHeaderCell = styled((props: ItemTableCellProps) => <ItemTableCell {...props} />)(
  {
    fontSize: '13px',
    fontWeight: 500,
    padding: '0.5em 1em',
    whiteSpace: 'nowrap'
  },
  {
    name: 'AreaSubstrateHeaderCell'
  }
)

export default AreaSubstrateHeaderCell
